import {Component, OnInit, Input} from '@angular/core';
import {ProventumApiService} from '@app/services/proventum-api.service';
import {Globals} from "@app/services/globals.service";


@Component({
    selector: 'app-comment-item',
    templateUrl: './comment-item.component.html',
    styleUrls: ['./comment-item.component.css']
})
export class CommentItemComponent implements OnInit {

    previewCommentItem = false;
    @Input() commentData: object;
    fullName = '';
    avatar = '';
    shortName = '';
    comment = '';
    leftTime = '';
    avatarObject = {};
    attachments = [];

    constructor(public proventumApiService: ProventumApiService, public globalsService: Globals) {

    }

    ngOnInit(): void {
        this.comment = this.commentData['comment'];
        this.leftTime = this.commentData['leftTime'];
        this.attachments = this.commentData['attachments'];
        let users = this.globalsService.getAllUsers();

        let creatorData = users.find(item => item.id === this.commentData['creator']);
        if (creatorData != undefined && creatorData != null) {
            this.avatarObject = creatorData;
            this.previewCommentItem = true;
            this.fullName = creatorData.first_name + ' ' + creatorData.last_name;
            this.avatar = creatorData.avatar;
            this.shortName = creatorData.shortName;
        }

    }

}
